import EventPreCheckInPage, { isEventPreCheckInPath } from "./components/pages/Events/EventPreCheckInPage";
import React, { ReactElement, useEffect, useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { RoutePaths } from "./enumStrings";
import useInitialAuth from "./hooks/useInitalAuth";
import getApolloClient from "./apolloClient";
import { ApolloClient, ApolloProvider } from "@apollo/client";
import FullPageLoader from "./components/common/FullPageLoader";
import Root from "./components/pages/Root/Root";
import Login from "./components/pages/Auth/Login";
import ForgotPassword from "./components/pages/Auth/ForgotPassword";
import NewPassword from "./components/pages/Auth/NewPassword";
import Error500 from "./components/pages/ErrorPages/Error500";
import LoggedInApp from "./components/LoggedInApp";
import NativeDatePickerClickOpener from "./components/common/dashboard/NativeDatePickerClickOpener";
import NewVersionBanner from "./components/common/NewVersionBanner";
import { useHandleLogout } from "./hooks/useHandleLogout";
import useIsOffline from "./hooks/useIsOffline";
import OfflineScreen from "./components/common/offline/OfflineScreen";
import SecureCheckoutReturnPage, {
  isSecureCheckoutReturnPath,
} from "./components/pages/Invoicing/SecureCheckoutReturnPage";

export const DashboardApp = (): ReactElement => {
  const [client, setClient] = useState(
    null as unknown as ApolloClient<unknown>
  );
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useInitialAuth(setIsLoggedIn);

  const handleLogout = useHandleLogout();
  const isOffline = useIsOffline();

  useEffect(() => {
    getApolloClient(handleLogout).then((newClient) => {
      setClient(newClient);
      setIsLoading(false);
    });
  }, [handleLogout, isLoggedIn]);

  if (isLoading || isLoggedIn === null) {
    // Offline design C: the sign-in check cannot finish with no internet.
    return isOffline ? <OfflineScreen /> : <FullPageLoader />;
  }

  return (
    <ApolloProvider client={client}>
      <NativeDatePickerClickOpener />
      <NewVersionBanner />
      <Routes>
        {/* Signed in, /500 shows inside the dashboard (LoggedInApp). */}
        {isLoggedIn === false ? (
          <Route
            path={RoutePaths.error500}
            element={<Error500 placement="standalone" />}
          />
        ) : null}
        <Route path={RoutePaths.home} element={<Root />} />
        {isLoggedIn === false ? (
          <Route path="*" element={<LoggedOutApp />} />
        ) : (
          <Route path="*" element={<LoggedInApp />} />
        )}
      </Routes>
    </ApolloProvider>
  );
};

const App = (): ReactElement => {
  if (isEventPreCheckInPath(window.location.pathname)) return <EventPreCheckInPage />;
  if (isSecureCheckoutReturnPath(window.location.pathname)) {
    return <SecureCheckoutReturnPage />;
  }

  return <DashboardApp />;
};

const LoggedOutApp = (): ReactElement => {
  return (
    <Routes>
      <Route path={RoutePaths.login} element={<Login />} />
      <Route path={RoutePaths.forgotPassword} element={<ForgotPassword />} />
      <Route path={RoutePaths.newPassword} element={<NewPassword />} />
    </Routes>
  );
};

export default App;
